import {Label} from 'platform/components';
import {Stack, Text, VStack} from 'platform/foundation';

import {suffixTestId, TestIdProps} from 'shared/web';

import i18n from '../../../../i18n/i18n';
import {FeaturesFilterDialog} from './FeaturesFilterDialog';
import {FeaturesFilterTrigger} from './FeaturesFilterTrigger';

export type FeaturesFilterFieldBodyVariant = 'stacked' | 'inline';

export interface FeaturesFilterFieldBodyProps extends TestIdProps {
  variant: FeaturesFilterFieldBodyVariant;
  sortedFeatureItems: Array<{key: string; label: string}>;
  draftValue: string[];
  isOpen: boolean;
  isLoading: boolean;
  isTriggerDisabled?: boolean;
  onDraftChange: (value: string[]) => void;
  onOpen: () => void;
  onClose: () => void;
  onConfirm: (value: string[]) => void;
  onChange: (value: string[]) => void;
}

export function FeaturesFilterFieldBody(props: FeaturesFilterFieldBodyProps) {
  const {
    variant,
    sortedFeatureItems,
    draftValue,
    isOpen,
    isLoading,
    isTriggerDisabled,
    onDraftChange,
    onOpen,
    onClose,
    onConfirm,
    onChange,
  } = props;

  const trigger = (
    <FeaturesFilterTrigger
      items={sortedFeatureItems}
      onOpen={onOpen}
      onChange={onChange}
      isDisabled={isTriggerDisabled}
      isLoading={isLoading}
      data-testid={suffixTestId('featuresFilterTrigger', props)}
    />
  );

  const dialog = (
    <FeaturesFilterDialog
      isOpen={isOpen}
      draftValue={draftValue}
      onDraftChange={onDraftChange}
      isLoading={isLoading}
      isMultiselect
      onClose={onClose}
      onConfirm={onConfirm}
      data-testid={suffixTestId('dialog', props)}
    />
  );

  if (variant === 'inline') {
    return (
      <VStack spacing={1}>
        <Stack
          direction={['column', 'row']}
          align={[undefined, 'center']}
          justify="space-between"
          spacing={2}
        >
          <Text size="small" data-testid={suffixTestId('label', props)}>
            {i18n.t('entity.filterForm.features')}
          </Text>
          {trigger}
        </Stack>
        {dialog}
      </VStack>
    );
  }

  return (
    <VStack>
      <Label data-testid={suffixTestId('label', props)}>
        {i18n.t('entity.filterForm.features')}
      </Label>
      {trigger}
      {dialog}
    </VStack>
  );
}
